"use strict";

export class Spinner {
    #container
    #overlay

    constructor(container = 'body') {
        this.#container = $(container)
    }

    show(text = "") {
        this.#overlay
        if (!this.#overlay || !this.#overlay.length) {
            this.#overlay = $('<div>')
                .addClass('spinner-overlay')
                .append($('<div>').addClass('spinner')
                    .prepend(
                        $('<img>').attr('src', '/static-icons/spinner-light.svg')
                    )
                    .append($('<p>').text(text))
                )
                .prependTo($(this.#container))
                .on('click', () => {
                    return false
                });
        }
    }

    remove() {
        this.#overlay.remove();
    }

    text(text) {
        $(this.#overlay).find('div.spinner p').text(text);
    }
}
if (!window.spinner) {
    window.spinner = new Spinner('body')
}
